import axios from 'axios'
import {API_URL} from "./Endpoints"
import {eventBus} from '@/main.js'

export default {

	// ============================
	// TOURNAMENTS
	// ============================

	getTournaments() {
		return axios({
				method: 'get',
				url: API_URL + '/tournaments/'
			})
			.then(response => {
				// console.log(response.data.data);
				return response.data.data;
			})
	},

	getTournamentTeams(tournamentId) {
		return axios({
				method: 'get',
				url: API_URL + '/tournaments/' + tournamentId + '/teams'
			})
			.then(response => {
				return response.data.data;
			})
	},

	getTeams() {
		return axios({
				method: 'get',
				url: API_URL + '/teams'
			})
			.then(response => {
				return response.data.data;
			})
	},

	getPlayers(tournamentId, teamId) {
		return axios({
				method: 'get',
				url: API_URL + '/tournaments/' + tournamentId + '/teams/' + teamId + '/users'
			})
			.then(response => {
				return response.data.data;
			})
	},
	
	getStat(filters) {
		return axios({
				method: 'get',
				url: API_URL + '/statistics',
				params: filters 
			})
			.then(response => {
				// console.log(response.data);
				return response.data;
			})
			.catch(error => {
				console.log(error);
			})
	},

	addStat(stat, local=false) {
		return axios({
				method: 'post',
				url: API_URL + '/statistics',
				data: stat,
			})
			.then(response => {
				// console.log("Add stat success:", response.data)
				return response
			})
			.catch(error => {
				// console.log("Add stat error!", error)
				let storedStat = localStorage.getItem('statistics'),
					statistics = [],
					response = error.response.status + " : " + error.response.statusText;

				if ( storedStat ) { statistics = JSON.parse(storedStat); }

				statistics.push(stat);
				localStorage.setItem('statistics', JSON.stringify(statistics));

				if(!local){
					eventBus.$emit('add-stat-error');
				}

				return response
			})
	},

}


// WEBPACK FOOTER //
// ./src/api/Requests.js